<template>
  <!-- 解决方案 -->
  <div :class="isPcFlag ? 'solution-box-pc' : 'solution-box-h5'">
    <div class="content">
      <div class="title">解决方案</div>
      <!-- PC样式 -->
      <div class="swiper-box" v-if="isPcFlag">
        <div class="swiper-container" ref="interSwiper" id="swiper_container" @mouseenter="enterFn" @mouseleave="leaveFn">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, index) in list" :key="index">
              <div class="text">{{ item.title }}</div>
              <img :src="item.img" />
            </div>
          </div>
        </div>
        <div class="button-prev" @click="swiperPrev">
          <img src="../../../assets/images/landing-ofd/left_btn.png" alt="" />
        </div>
        <div class="button-next" @click="swiperNext">
          <img src="../../../assets/images/landing-ofd/right_btn.png" alt="" />
        </div>
      </div>
      <!-- H5样式 -->
      <div class="card-list" v-else>
        <div class="card-item" v-for="(item, index) in list" :key="index">
          <div class="text">{{ item.title }}</div>
          <img class="img" :src="item.img" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'
export default {
  props: {
    isPcFlag: Boolean, // 是Pc还是H5
    list: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      planSwiper: '',
    }
  },
  mounted() {
    this.initSwiper()
  },
  methods: {
    initSwiper() {
      this.planSwiper = new Swiper('.swiper-container', {
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: true, //悬停停止切换
        },
        spaceBetween: 30,
        slidesPerView: 3,
      })
    },
    swiperPrev() {
      this.planSwiper.slidePrev()
      setTimeout(() => {
        this.leaveFn()
      }, 5000)
    },
    swiperNext() {
      this.planSwiper.slideNext()
      setTimeout(() => {
        this.leaveFn()
      }, 5000)
    },
    enterFn() {
      this.planSwiper && this.planSwiper.autoplay.stop()
    },
    leaveFn() {
      this.planSwiper && this.planSwiper.autoplay.start()
    },
  },
}
</script>

<style lang="less" scoped>
@import '../../../assets/css/swiper.min.css';
.basisDisplay(@justify,@align) {
  display: flex;
  justify-content: @justify;
  align-items: @align;
}
.columnDisplay(@justify,@align) {
  display: flex;
  flex-direction: column;
  justify-content: @justify;
  align-items: @align;
}
.solution-box-pc {
  width: 100%;
  background: #f7f8fa;
  padding: 72px 0;
  .content {
    max-width: 1320px;
    height: 100%;
    margin: 0 auto;
    .columnDisplay(flex-start,center);
    .title {
      margin-bottom: 46px;
      font-size: 32px;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.85);
    }
    .swiper-box {
      width: 90%;
      position: relative;

      .button-prev {
        position: absolute;
        top: 80px;
        left: -60px;
        width: 35px;
        height: 35px;
        cursor: pointer;
      }
      .button-next {
        position: absolute;
        top: 80px;
        right: -60px;
        width: 35px;
        height: 35px;
        cursor: pointer;
      }
      .swiper-container {
        width: 100%;

        .swiper-wrapper {
          .swiper-slide {
            object-fit: cover;
            width: 33%;
            height: 190px;
            background: #ffffff;
            box-shadow: 0px 4px 10px 0px #eaf0f7;
            border-radius: 4px;
            .text {
              padding: 24px 0 11px 0;
              text-align: center;
              font-size: 20px;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.85);
            }
          }
        }
      }
    }
  }
}
.solution-box-h5 {
  width: 100%;
  background: #f7f8fa;
  padding: 1.0667rem 0.4rem;
  .content {
    max-width: 10rem;
    height: 100%;
    margin: 0 auto;
    .columnDisplay(flex-start,center);
    .title {
      margin-bottom: 0.64rem;
      font-size: 0.48rem;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
    }
    .card-list {
      width: 100%;
      .basisDisplay(space-between,center);
      flex-wrap: wrap;
      .card-item {
        width: 48%;
        padding: 0 0 0.3467rem 0;
        margin-bottom: 0.32rem;
        border-radius: 0.1067rem;
        background: #fff;
        box-shadow: 0px 0.1067rem 0.16rem 0px #eaf0f7;
        .text {
          font-size: 0.3733rem;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.85);
          padding: 0.4rem 0 0.1867rem 0.3733rem;
        }
        .img {
          width: 100%;
          // height: 1.7067rem;
        }
      }
    }
  }
}
</style>